/*
Author: Vaishnavi
Date: 18/11/2019
Issue Description: Visual bugs assigned by Harshvardhan Kore & Tarun Bhandari
*/
/*
Author: Shivakumar
Date: 20/03/2020
Issue Description: [Navigation] When clicked on Text or LE logo it should navigate to Payroll dashborad screen
search_string: PL_2965
*/


<template>
  <div class="container-org-summary">
    <tool-bar />
    <div class="content-wrapper"></div>
    <tl-header type="h1">
      <div>Organisation Summary</div>
    </tl-header>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => (toast = val)"
    />
    <div class="addOrgClass" @click="addnewOrg()" v-if="!onboardingOrgId">
      <button class="addnewempbtn" @click="addnewOrg()" v-show="!searchemp">
        <img src="@/assets/group-5.svg" />
        <b>Add New Organisation</b>
      </button>
    </div>
    <div
      class="addedOrgClass"
      @click="editOrg(onboardingOrgId)"
      v-else
      :disabled="ifTeamLeader || ifAnchor || ifAuditor"
    >
      <div class="orgDetails">
        <img src="@/assets/org.svg" v-if="!formData.logo" class="orgImg" />
        <img class="orgImg" :src="formData.logo" v-if="formData.logo" />
        <div class="lename_leaddress">
          <div class="orgLabel" @click="editOrg(onboardingOrgId)">
            {{ formData.name }}
          </div>

          <span v-show="!ifAuditor" class="favouriteOrgIcons">
            <!-- <img
              v-if="!showFavOrgStar"
              class="start-class"
              src="@/assets/star_normal.svg"
              @click="makeOrgFavOrUnFav(showFavOrgStar)"
              title="Mark as favourite"
            /> -->
            <!-- <img
              v-if="showFavOrgStar"
              class="start-class"
              src="@/assets/star_active.svg"
              @click="makeOrgFavOrUnFav(showFavOrgStar)"
              title="Mark as un favourite"
            /> -->
            <img src="@/assets/edit.svg" @click="editOrg(onboardingOrgId)" />
          </span>
          <br />
          <div class="margin-t-l">{{ orgAddress }}</div>
        </div>
      </div>
    </div>
    <tl-header class="h3">Legal Entities</tl-header>
    <div class="addbtn" v-if="leList.length > 0">
      <button
        class="addnewempbtn"
        @click="addnewLe()"
        v-if="
          (!ifTeamLeader && !ifAnchor && !ifAuditor) || ifSuperAdminPermission
        "
        :disabled="!(ifSuperAdminPermission || ifTeamAnchorAuditorPermission)"
      >
        <img src="@/assets/group-5.svg" />
        <span>
          <b>Add New</b>
        </span>
      </button>
    </div>
    <div
      v-if="leList.length == 0"
      @click="addnewLe()"
      :class="{ addLeClass: onboardingOrgId, noOrgClass: !onboardingOrgId }"
    >
      <button
        :class="{
          addnewempbtn: onboardingOrgId,
          addnewempbtngrey: !onboardingOrgId,
        }"
        @click="addnewLe()"
      >
        <img v-if="!onboardingOrgId" src="@/assets/group-5-grey.svg" />
        <img v-else src="@/assets/group-5.svg" />
        <b
          :class="{
            addnewemptext: onboardingOrgId,
            addnewemptextgrey: !onboardingOrgId,
          }"
          >Add New Legal Entities</b
        >
      </button>
    </div>

    <div
      v-if="lessLeList.length"
      class="container-le-list"
      :disabled="!(ifSuperAdminPermission || ifTeamAnchorAuditorPermission)"
    >
      <div class="leDetails" v-if="showLess">
        <div
          class="addedLeClass"
          v-for="(les, index) in lessLeList"
          :key="index"
        >
          <div class="custom-grid" v-if="index !== 5">
            <img
              class="leImg"
              src="@/assets/legal_entity.svg"
              v-if="!les.logo"
            />
            <img class="leImg" v-bind:src="les.logo" v-if="les.logo" />
            <div
              class="textClass"
              @click="gotoPayrollDashboardOfLE(les.id, index)"
            >
              <div class="leLabel le-name">{{ les.name }}</div>
              <div class="margin-t-15px le-name" v-if="index !== 5">
                {{ les.address }} <br />
                {{ les.clientCode }}
              </div>
            </div>
            <div class="action-menu" v-show="!ifAuditor">
              <!-- <img
                v-if="!les.favourite"
                class="favourite"
                src="@/assets/star_normal.svg"
                @click="makeLeFavUnFav(les.favourite, les.id)"
                title="Mark as favourite"
              /> -->
              <!-- <img
                v-if="les.favourite"
                class="favourite"
                src="@/assets/star_active.svg"
                @click="makeLeFavUnFav(les.favourite, les.id)"
                title="Mark as un favourite"
              /> -->
              <img v-show="!ifAuditor"
                class
                src="@/assets/edit.svg"
                @click="editLe(les.id, index)"
              />
            </div>
          </div>

          <div class="viewAllbtn" v-if="index == 5" @click="viewAll()">
            <button class="addnewempbtn">
              <b>View All</b>
            </button>
          </div>
        </div>
      </div>
      <div class="leDetails showLeDetails" v-if="!showLess">
        <div
          class="addedLeClass"
          v-for="(les, index) in lessLeList"
          :key="index"
        >
          <div class="custom-grid">
            <img
              src="@/assets/legal_entity.svg"
              v-if="!les.logo"
              class="leImg"
            />
            <img class="leImg" v-bind:src="les.logo" v-if="les.logo" />
            <div
              class="textClass"
              @click="gotoPayrollDashboardOfLE(les.id, index)"
            >
              <div class="leLabel le-name">{{ les.name }}</div>
              <div class="margin-t-15px le-name">{{ les.address }}</div>
              <div class="margin-t-15px le-name">{{ les.clientCode }}</div>
            </div>
            <div v-show="!ifAuditor" class="action-menu">
              <!-- <img
                v-if="!les.favourite"
                class="favourite"
                src="@/assets/star_normal.svg"
                @click="makeLeFavUnFav(les.favourite, les.id)"
                title="Mark as favourite"
              /> -->
              <!-- <img
                v-if="les.favourite"
                class="favourite"
                src="@/assets/star_active.svg"
                @click="makeLeFavUnFav(les.favourite, les.id)"
                title="Mark as un favourite"
              /> -->
              <img
                class
                src="@/assets/edit.svg"
                @click="editLe(les.id, index)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="buDetails">
      <div class="col-6 businessHeaders">
        <tl-header class="h3">Business Units</tl-header>
        <div class="addbtnbu" v-if="businessUnitsData.length > 0">
          <button class="addnewempbtn" @click="addnewBu()">
            <img src="@/assets/group-5.svg" />
            <span>
              <b>Add New</b>
            </span>
          </button>
        </div>
      </div>
      <div class="col-6">
        <tl-header class="h3-buType">Business Types</tl-header>
        <div class="addbtnbu" v-if="businessUnitTypes.length > 0">
          <button class="addnewempbtn" @click="addnewBuType()">
            <img src="@/assets/group-5.svg" />
            <span>
              <b>Add New</b>
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="buDetailsCards">
      <div
        class="addedOrgBuClass"
        :class="{'greenBorder': onboardingOrgId, 'greyBorder': !onboardingOrgId}"
        v-if="!onboardingOrgId || businessUnitsData.length == 0"
      >
        <button
          :class="{'addnewempbtn': onboardingOrgId, 'addnewempbtngrey': !onboardingOrgId}"
          :disabled="!onboardingOrgId"
          @click="addnewBu()"
        >
          <img v-if="!onboardingOrgId" src="@/assets/group-5-grey.svg" />
          <img v-else src="@/assets/group-5.svg" />
          <b
            :class="{'addnewemptext': onboardingOrgId, 'addnewemptextgrey': !onboardingOrgId}"
          >Add New Business Units</b>
        </button>
      </div>
      <div class="addedBuClass" v-if="businessUnitsData.length>0">
        <div class="org-header">
          <div class="text-purple">
            <span class="suffix">
              <b>{{businessUnitsData.length}}</b>&nbsp;Business Unit/s added
            </span>
          </div>
          <div class="divider thin"></div>
          <span
            class="sub-text"
            v-for="(unit, index) in businessUnitsData"
            :key="index"
          >{{unit.name}}</span>
        </div>
        <div class="view-btn-bu-2">
          <btn
            text="View All"
            type="secondary"
            class="view-all-btn"
            @click="goToBusinessUnitsPage"
          />
        </div>
      </div>
      <div
        class="addedOrgBuClass"
        :class="{'greenBorder': onboardingOrgId, 'greyBorder': !onboardingOrgId}"
        v-if="!onboardingOrgId || businessUnitTypes.length==0"
      >
        <button
          :disabled="!onboardingOrgId"
          :class="{'addnewempbtn': onboardingOrgId, 'addnewempbtngrey': !onboardingOrgId}"
          @click="addnewBuType()"
        >
          <img v-if="!onboardingOrgId" src="@/assets/group-5-grey.svg" />
          <img v-else src="@/assets/group-5.svg" />
          <b
            :class="{'addnewemptext': onboardingOrgId, 'addnewemptextgrey': !onboardingOrgId}"
          >Add New Business Type</b>
        </button>
      </div>
      <div class="addedBuTypeClass" v-else>
        <div class="org-header">
          <div class="text-purple">
            <span class="suffix">
              <b>{{businessUnitTypes.length}}</b>&nbsp;Business Type/s added
            </span>
          </div>
          <div class="divider thin"></div>
          <span
            class="sub-text"
            v-for="(type, index) in businessUnitTypes"
            :key="index"
          >{{type.name}}</span>
        </div>
        <div class="view-btn-bu-2">
          <btn
            text="View All"
            type="secondary"
            class="view-all-btn"
            @click="goToBusinessUnitTypesPage"
          />
        </div>
      </div>
    </div> -->
    <bottom-action-container class="position-fixed bottom-action-container">
      <btn-grp slot="end">
        <btn text="Go to Home" type="primary" class @click="goToHome()"></btn>
      </btn-grp>
    </bottom-action-container>

    <pop-up-message
      v-if="showSuccessMsg"
      :message="popupMessage"
      btnText="OK"
      @back="closeModal()"
    ></pop-up-message>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import * as config from "@/apis/config.js";
import toolBar from "../../dashboard/views/shell/dashboardToolbar.vue";
import { eventBus } from "@/main";
export default {
  components: {
    toolBar,
},
  data() {
    return {
      showSuccessMsg: false,
      popupMessage: "",
      showFavOrgStar: false,
      errmsg: "",
      toast: false,
      countriesListData: [],
      statesListData: [],
      legalEntityList: [],
      orgAddress: "",
      leList: [],
      lessLeList: [],
      businessUnitsData: [],
      businessUnitTypes: [],
      showLess: true,
      formData: {
        id: null,
        name: "",
        code: "",
        logo: "",
        pincode: "",
        stateName: "",
        cityName: "",
        addressLineOne: "",
        addressLineTwo: "",
        country: null,
        phonenumber: "",
        orgEmail: "",
      },
      createLegalEntityValue: false,
      legalEntityListValue: false,
      role: ""
    };
  },
  activated() {
    this.getGlobalData();
    this.getOrgData();
    this.getLeData();
    this.fetchBu();

    this.fetchBuTypes();
    this.getOrgLeIdList();
  },
  mounted() {
    this.getGlobalData();
    this.getOrgData();
    this.getLeData();
    this.fetchBu();
    this.fetchBuTypes();
    this.getOrgLeIdList();
    this.refreshLocalStorage();

  },
  computed: {
    ...mapState({
      orgId: (state) => state.auth.org_id,
      email: (state) => state.auth.email,
      onboardingOrgId: (state) => state.onboard.organization.id,
      isOrgFavourite: (state) => state.onboard.organization.isFavourite,
      favouriteOrganisations: (state) =>
        state.onboard.organization.allOrgsData.favOrgs,
      isFetching: (state) => state.onboard.organization.isFetching,
      isSaving: (state) => state.onboard.organization.isSaving,
      auth: (state) => state.auth,
      globalData: (state) => state.globalapi.globalData,
    }),
    getOrgId() {
      return this.orgId;
    },
    isLoading() {
      return this.isFetching;
    },
    ifTeamLeader() {
      return localStorage.getItem("userRole") == "TEAMLEADER" ? true : false;
    },
    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },
    ifAuditor() {
      return localStorage.getItem("userRole") == "AUDITOR" ? true : false;
    },
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ifSuperAdminPermission() {
      if (this.role === "SUPERADMIN" || this.role === 'ADMIN') {
        // if (this.createLegalEntityValue || this.legalEntityListValue) {
          return true;
        } else {
          return false;
        }
      // } else {
      //   return true;
      // }
    },
    refreshLocalStorage() {
      localStorage.removeItem("token1")
      localStorage.removeItem("userRole1")
      localStorage.removeItem("loginId1")
      localStorage.removeItem("employeeId1")
    },
    ifTeamAnchorAuditorPermission() {
      if (
        this.role === "TEAMLEADER" ||
        this.role === "ANCHOR" ||
        this.role === "AUDITOR"
      ) {
        if (this.legalEntityListValue) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    ifAdmin() {
      return localStorage.getItem("userRole") == "ADMIN" ? true : false;
    },
  },
  methods: {
    ...mapActions({
      act_fetch: "onboard/organization/fetchAll",
      act_create: "onboard/organization/create",
      act_update: "onboard/organization/update",
      act_makeOrganisation_favourite_unFavourite:
        "onboard/organization/markOrganisationAsFavOrUnFav",
      act_changeMode: "onboard/legal_entities/changeMode",
      act_fileUpload: "onboard/file_upload/create",
      act_fetchglobalData: "globalapi/globalData/fetchAll",
      act_fetchBu: "onboard/business_units/fetchAll",
      act_fetchBuType: "onboard/butypes/fetchAll",
      act_fetchle: "onboard/legal_entities/fetchAll",
      act_setOrgId: "onboard/organization/changeOrgId",
      act_changeEditMode_businessUnit: "onboard/business_units/changeEditMode",
      act_changeEditMode_BUtype: "onboard/butypes/changeEditMode",
      getOrgLeList: "onboard/organization/getOrgLeIdList",
      getFavouriteOrgs: "onboard/organization/fetchFavouriteOrg",
    }),

    /** Function to make an organisation as favourite/unfavourite */
    // async makeOrgFavOrUnFav(showFavOrgStar) {
    //   try {
    //     let res = await this.act_makeOrganisation_favourite_unFavourite({
    //       data: {
    //         id: this.onboardingOrgId,
    //         name: this.formData.name,
    //         email: this.email,
    //         isFavourite: !showFavOrgStar
    //       }
    //     });
    //
    //     if (res.data.status) {
    //       this.showFavOrgStar = !showFavOrgStar;
    //       this.popupMessage = res.data.message;
    //       this.showSuccessMsg = true;
    //     }
    //   } catch (err) {
    //     this.toast = true;
    //     this.errmsg = err;
    //   }
    // },
    /** Function to close the modal */
    closeModal() {
      this.showSuccessMsg = false;
    },
    /** Function to make an LE as favourite/unfavourite */
    makeLeFavUnFav(favourite, index) {
      try {
        for (let i = 0; i < this.leList.length; i++) {
          if (index == this.leList[i].id) {
            this.leList[i].favourite = !favourite;
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** Navigation to an organisation */
    addnewOrg() {
      eventBus.$emit("Organization");
      this.$router.push("/onboarding/info");
    },
    /** Navigation to an organisation to edit */
    editOrg(val) {
      this.act_setOrgId(val);
      this.$router.push({ path: "onboarding/info" });
    },
    /** Navigation to add an LE */
    addnewLe() {
      this.act_changeMode({ editMode: false, record: {} });
      this.$router.push({
        name: "onboardingle",
        params: {
          level: "org",
          step_name: "legal_entities",
          index: this.leList.length,
        },
      });
    },
    /** Navigation to add BU */
    async addnewBu() {
      try {
        await this.act_changeEditMode_businessUnit({
          editMode: false,
          record: {},
        });

        this.$router.push({
          path: `/onboarding/business_units/addBusiness`,
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Navigation to add BU */
    async addnewBuType() {
      try {
        await this.act_changeEditMode_BUtype({ editMode: false, record: {} });
        this.$router.push({
          path: `/onboarding/business_units/addBusinessUnitType`,
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    goToHome() {
      this.$router.push("/welcome");
    },
    /** PL_2965 */
    gotoPayrollDashboardOfLE(val, index) {
      try {
        let editableRecord = this.legalEntityList[index];
        this.act_changeMode({ editMode: true, record: editableRecord });

        if(localStorage.getItem("userRole") == "AUDITOR") {
            this.$router.push({
            path: `/dashboard/${index}/payroll/payroll/incometaxproofapproval`
          });
        } else {
          this.$router.push({
            path: `/dashboard/${index}/payroll/monthlypayroll`,
          });
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /* PL_2965 */
    /** Navigation to Edit an LE info */
    editLe(val, index) {
      try {
        let editableRecord = this.legalEntityList[index];
        this.act_changeMode({ editMode: true, record: editableRecord });
        this.$router.push({
          name: "onboardingent",
          params: {
            level: "entity",
            step_name: "legal_entities",
            entity_index: index,
            sub_step: "modifyLegalEntity",
          },
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to get the Global data from server if it is not fetched atleast once */
    async getGlobalData() {
      try {
        this.countriesListData = config.GlobalList.countriesList;
        this.formData["country"] = this.setCountryObj();
        if (!this.globalData.isGlobalDataFetched) {
          let res = await this.act_fetchglobalData();
          this.statesListData = res.data.payload.State;
        } else {
          this.statesListData = this.globalData.data.State;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
      this.getOrgData();
    },
    /** Function to fetch the organisation data */
    async getOrgData() {
      try {
        let organisationID = this.onboardingOrgId;
        if (organisationID) {
          let res = await this.act_fetch(organisationID);
          if (res.data.status) {
            this.formData["name"] = res.data.payload.data[0].name;
            this.formData["code"] = res.data.payload.data[0].code;
            this.formData["addressLineOne"] = res.data.payload.data[0]
              .headOfficeAddress
              ? res.data.payload.data[0].headOfficeAddress.addressLineOne
              : "";
            this.formData["addressLineTwo"] = res.data.payload.data[0]
              .headOfficeAddress
              ? res.data.payload.data[0].headOfficeAddress.addressLineTwo
              : "";
            this.formData["pincode"] = res.data.payload.data[0]
              .headOfficeAddress
              ? res.data.payload.data[0].headOfficeAddress.pincode
              : "";
            this.formData["stateName"] = this.setStateObj(
              res.data.payload.data[0].headOfficeAddress
                ? res.data.payload.data[0].headOfficeAddress.stateID
                : ""
            );
            this.formData["cityName"] = this.setCityObj(
              res.data.payload.data[0].headOfficeAddress
                ? res.data.payload.data[0].headOfficeAddress.cityID
                : ""
            );
            this.formData["country"] = this.setCountryObj();
            this.formData["orgEmail"] = res.data.payload.data[0]
              .headOfficeAddress
              ? res.data.payload.data[0].headOfficeAddress.email
              : "";
            this.formData["phonenumber"] = res.data.payload.data[0]
              .headOfficeAddress
              ? res.data.payload.data[0].headOfficeAddress.phonenumber
              : "";
            this.formData["logo"] = res.data.payload.data[0].logoURL;

            let addressLineOneString = this.formData["addressLineOne"]
              ? this.formData["addressLineOne"]
              : "";
            let addressLineTwoString = this.formData["addressLineTwo"]
              ? this.formData["addressLineTwo"]
              : "";
            let cityNameString = this.formData["cityName"]
              ? this.formData["cityName"].city_name
              : "";
            let stateNameString = this.formData["stateName"]
              ? this.formData["stateName"].state_name
              : "";
            let pincodeString = this.formData["pincode"];

            this.orgAddress =
              (addressLineOneString ? addressLineOneString + ", " : "") +
              (addressLineTwoString ? addressLineTwoString + ", " : "") +
              (cityNameString ? cityNameString + ", " : "") +
              (stateNameString ? stateNameString : "") +
              (pincodeString ? " - " + pincodeString : "");
            this.showFavOrgStar = this.isOrgFavourite;
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to fetch the List of LEs for an Organisation */
    async getLeData() {
      try {
        let res = await this.act_fetchle(this.onboardingOrgId);
        let organisationID = this.onboardingOrgId;
        this.legalEntityList = res.data.payload.data;
        for (let i = 0; i < this.legalEntityList.length; i++) {
          if (this.legalEntityList[i].org_id == organisationID) {
            /*** START: Show the legal enitity according to anchor user role */
            if (res.data.user) {
              if (res.data.user.userRole === "ANCHOR") {
                const permissionOrgs = res.data.user.organisations;
                if (permissionOrgs[this.legalEntityList[i].org_id]) {
                  const testArray =
                    permissionOrgs[this.legalEntityList[i].org_id][
                      "legal_entity"
                    ];
                  const orgId = this.legalEntityList[i].id;
                  const valid = testArray.find((i) => i.id === orgId);
                  if (valid) {
                    let obj = {
                      id: this.legalEntityList[i].id,
                      name: this.legalEntityList[i].legalName,
                      logo: this.legalEntityList[i].logoURL,
                      address: this.legalEntityList[i].headOfficeAddress.cityID
                        ? this.getCityNameById(
                            this.legalEntityList[i].headOfficeAddress.cityID,
                            this.legalEntityList[i].headOfficeAddress.stateID
                          )
                        : "",
                      favourite: false,
                      org_id: this.legalEntityList[i].org_id,
                      clientCode: this.legalEntityList[i].clientCode
                    };
                    this.leList.push(obj);
                  }
                }
              } else {
                let obj = {
                  id: this.legalEntityList[i].id,
                  name: this.legalEntityList[i].legalName,
                  logo: this.legalEntityList[i].logoURL,
                  address: this.legalEntityList[i].headOfficeAddress.cityID
                    ? this.getCityNameById(
                        this.legalEntityList[i].headOfficeAddress.cityID,
                        this.legalEntityList[i].headOfficeAddress.stateID
                      )
                    : "",
                  favourite: false,
                  org_id: this.legalEntityList[i].org_id,
                  clientCode: this.legalEntityList[i].clientCode
                };
                this.leList.push(obj);
               }
            }
          }
        }
        /*** END: Show the legal enitity according to anchor user role */
        this.lessLeList = this.leList.slice(0, 6);
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to fetch the city name by an id */
    getCityNameById(cityID, stateID) {
      if (cityID && stateID) {
        let stateIndex = this.statesListData.findIndex(
          (ele) => ele.id == stateID
        );
        if (stateIndex > -1) {
          let citiesListArray = this.statesListData[stateIndex].City;
          let cityIndex = citiesListArray.findIndex((ele) => ele.id == cityID);
          if (cityIndex > -1) {
            let cityObj = citiesListArray[cityIndex];
            return cityObj.city_name;
          }
        }
      }
    },
    /** Function to fetch the BUs list from server */
    async fetchBu() {
      try {
        let res = await this.act_fetchBu(this.onboardingOrgId);
        this.businessUnitsData = res.data.payload.data;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to fetch the BU Types list from server */
    async fetchBuTypes() {
      try {
        let res = await this.act_fetchBuType(this.onboardingOrgId);
        this.businessUnitTypes = res.data.payload.data;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to set the state object from the existing states list aray from global data */
    setStateObj(stateid) {
      if (stateid && this.statesListData.length) {
        return this.statesListData.find((res) => res.id == stateid);
      }
    },
    /** Navigation to BU screen */
    goToBusinessUnitsPage() {
      this.$router.push({
        path: "/onboarding/business_units",
      });
    },
    /** Navigation to BUs Type screen */
    goToBusinessUnitTypesPage() {
      this.$router.push({
        path: "/onboarding/business_unit_types",
      });
    },
    /** To set the country object in drop down list */
    setCountryObj() {
      return this.countriesListData[0] ? this.countriesListData[0] : null;
    },
    /** To view all LEs */
    viewAll() {
      this.showLess = false;
      this.lessLeList = [...this.leList];
    },
    /** To set the city object to show it in drop down from the list of Cities in Global data */
    setCityObj(cityid) {
      if (cityid && this.formData.stateName) {
        return this.formData.stateName.City.find((res) => res.id === cityid);
      }
    },

    async getOrgLeIdList() {
      const org = this.orgId;
      const le = this.le_id;
      //console.log("Org:", org);
      //console.log("Le ID", le);

      let res = await this.getFavouriteOrgs();
      this.orgobject = res.data.user.organisations;
      //console.log("Org Object Data", this.orgobject);

      let bodyParams = this.orgobject;
      //let  data = await this.getOrgLeList();

      let data = await this.getOrgLeList({
        data: {
          ...bodyParams,
        },
      });

      /*** START: Show the organisation according to anchor user role */
      if (
        data.data.user.userRole === "SUPERADMIN" ||
        data.data.user.userRole === "TEAMLEADER" ||
        data.data.user.userRole === "ANCHOR" ||
        data.data.user.userRole === "AUDITOR" ||
        data.data.user.userRole === "ADMIN"
      ) {
        if (data.data.payload.data.length > 0) {
          let tempArray = [];
          // Added here logical part of legal enitity to find out enitity and org id
            const permissionOrgs = data.data.user.organisations;
                if (permissionOrgs[this.legalEntityList[i].org_id]) {
                  const testArray =
                    permissionOrgs[this.legalEntityList[i].org_id][
                      "legal_entity"
                    ];
                  const orgId = this.legalEntityList[i].id;
                  const valid = testArray.find((i) => i.id === orgId);
                  if (valid) {
                    let obj = {
                      id: this.legalEntityList[i].id,
                      name: this.legalEntityList[i].legalName,
                      logo: this.legalEntityList[i].logoURL,
                      address: this.legalEntityList[i].headOfficeAddress.cityID
                        ? this.getCityNameById(
                            this.legalEntityList[i].headOfficeAddress.cityID,
                            this.legalEntityList[i].headOfficeAddress.stateID
                          )
                        : "",
                      favourite: false,
                      org_id: this.legalEntityList[i].org_id,
                      clientCode: this.legalEntityList[i].clientCode
                    };
                    this.leList.push(obj);
                  }
                }
          // End here

          // data.data.payload.data.forEach((element) => {
          //   //console.log("Element", element.Organisation.name);
          //   //console.log("Legal Entity data",data.data.payload.data);
          //   tempArray.push({
          //     id: element.id,
          //     name: element.legalName,
          //     logo: element.logoURL,
          //     address: element.headOfficeAddress.cityID
          //       ? this.getCityNameById(
          //           element.headOfficeAddress.cityID,
          //           element.headOfficeAddress.stateID
          //         )
          //       : "",
          //     favourite: false,
          //     org_id: element.org_id,
          //   });
          // });
          // this.lessLeList = tempArray;
        }
        //this.leList.push(obj);
      }

      /*** END: Show the organisation according to anchor user role */

      this.role = data.data.user.userRole;
      //{org_id:this.orgId, le_id:this.le_id}
      this.createLegalEntityValue = data.data.user.permissions
        .create_legal_entity
        ? true
        : false;
      this.legalEntityListValue = data.data.user.permissions.legal_entity_list
        ? true
        : false;
      //console.log("PL-3406", data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
.container-org-summary {
  width: 100%;
  padding: 30px 100px 30px 100px;
  margin-bottom: 100px;
}
img {
  cursor: pointer;
}
.content-wrapper {
  padding: 50px 100px 0 100px;
}
.viewAllbtn {
  border-radius: 4px;
  height: 120px; // org: 92px
  display: flex; /* establish flex container */
  flex-direction: column; /* make main axis vertical */
  justify-content: center; /* center items vertically, in this case */
  align-items: center;
  border: solid 1px #34c0be;
  border-left: 1px dashed #34c0be;
  border-right: 1px dashed #34c0be;
  border-top: 1px dashed #34c0be;
  border-bottom: 1px dashed #34c0be;
  background-color: #ffffff;
}
.addOrgClass {
  width: 100%;
  height: 109px;
  border-radius: 4px;
  border: solid 1px #34c0be;
  border-left: 1px dashed #34c0be;
  border-right: 1px dashed #34c0be;
  border-top: 1px dashed #34c0be;
  border-bottom: 1px dashed #34c0be;
  background-color: #ffffff;
  margin-bottom: 45px;
  padding: 35px 400px 30px 345px;
  cursor: pointer;
}
.addedOrgClass {
  width: 100%;
  height: 109px;
  border-radius: 4px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  margin-bottom: 45px;
  cursor: pointer;
}
.addedOrgClass:hover {
  width: 100%;
  height: 109px;
  border-radius: 4px;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  margin-bottom: 45px;
  cursor: pointer;
}
.orgDetails {
  display: grid;
  grid-template-columns: 10% 88%;
  grid-gap: 1%;
  padding: 15px;
}
.orgImg {
  height: 67px;
  width: 100%;
  object-fit: contain;
}

.leImg {
  height: 48px;
  width: 100%;
  object-fit: contain;
}
.orgLabel {
  width: auto;
  float: left;
  height: 19px;
  font-family: Montserrat;
  font-size: 16px;
  margin-top: 13px;
  font-weight: bold;
  color: #5d409f;
}

.leLabel {
  width: auto;
  height: auto;
  font-size: 16px;
  font-weight: 500;
  color: #616363;
}

.start-class {
  margin-left: 250px;
  margin-right: 15px;
}

.addnewempbtn {
  display: flex;
  margin: auto;
  justify-content: center;
  height: 40px;
  color: #34c0be;
  font-size: 14px;
  border-radius: 4px;
  align-items: center;
  *:nth-child(n) {
    margin-right: 5px;
  }
}
.addnewemptext {
  color: #34c0be;
}
.addnewemptextgrey {
  color: #dadada;
}
.h3 {
  height: 19px;
  margin-right: 890px;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: bold;
  color: #6d7278;
  margin-bottom: 20px;
}
.addLeClass {
  width: 100%;
  padding: 35px;
  justify-content: center;
  display: flex;
  border-radius: 4px;
  border: dashed 1px #34c0be;
  background-color: #ffffff;
  cursor: pointer;
}
.leDetails {
  display: grid;
  grid-template-columns: 32.6% 32.6% 32.6%;
  grid-gap: 1.1%;
  height: auto;
  overflow-y: hidden;
}

.addedLeClass {
  width: 100%;
  //height: 92px;
  min-height: 120px;
  border-radius: 4px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  margin-bottom: 20px;
  cursor: pointer;
}
.addedLeClass:hover {
  width: 100%;
  //height: 92px;
  min-height: 120px;
  border-radius: 4px;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  margin-bottom: 20px;
  cursor: pointer;
}
.noOrgClass {
  width: 100%;
  height: 109px;
  border-radius: 4px;
  border: solid 1px #dddddd;
  border-left: 1px dashed #dddddd;
  border-right: 1px dashed #dddddd;
  border-top: 1px dashed #dddddd;
  border-bottom: 1px dashed #dddddd;
  background-color: #ffffff;
  pointer-events: none;
}

.addnewempbtngrey {
  display: flex;
  justify-content: center;
  height: 40px;
  color: #dadada;
  font-size: 14px;
  margin-left: 42.2%;
  border-radius: 4px;
  align-items: center;
  margin-top: 35px;
  *:nth-child(n) {
    margin-right: 5px;
  }
  img {
    color: #dddddd;
  }
}

.showIntro {
  cursor: pointer;
}
.favouriteOrgIcons {
  float: right;
  padding: 15px;
}
.help-text {
  width: 972px;
  height: 57px;
  font-family: $font-family;
  font-size: $font-size-l1;
  font-weight: 300;
  color: #404040;
}

.buDetails {
  display: flex;
  margin-top: 44px;
  width: 100%;
  .h3 {
    margin-right: auto;
    float: left;
  }
}
.businessHeaders {
  padding-left: 0px;
}
.h3-buType {
  height: 19px;
  font-size: 16px;
  font-weight: bold;
  float: left;
  color: #6d7278;
  margin-right: auto;
  margin-left: 0px;
  .addbtnbu {
    float: right;
    display: flex;
    button {
      display: flex;
    }
    margin-top: -14px;
    margin-left: 20px;
    span {
      color: #34c0be;
      margin-left: 5px;
      margin-top: 5px;
    }
  }
}
.buDetailsCards {
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 20px;
  width: 100%;
}
.greenBorder {
  border: dashed 1px #34c0be;
}
.greyBorder {
  border: dashed 1px #dddddd;
}
.addedOrgBuClass {
  width: 100%;
  min-height: 116px;
  border-radius: 4px;
  margin: auto;
  display: flex;

  background-color: #ffffff;
}
.addedBuClass {
  width: 100%;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}
.org-header {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-left: 25px;
  margin-top: 20px;
  .sub-text {
    font-size: 14px;
    color: #000000;
    margin-left: 10px;
  }
  *:nth-child(n) {
    margin-bottom: 5px;
  }
}
.text-purple {
  color: $color-primary;
  font-size: $font-size-l1;
  font-weight: bold;
  padding: 4px 0 0 12px;
  &.entities {
    margin-top: 35px;
    margin-bottom: 20px;
  }
  .suffix {
    font-weight: normal;
    font-size: $font-size-small;
    b {
      font-size: 18px;
    }
  }
}
.divider {
  color: $color-secondary;
  border-bottom: 2px solid $color-secondary;
  width: 17%;
  &.thin {
    border-bottom: 1px solid $color-secondary;
    margin-left: 10px;
    margin-top: 5px;
  }
}
.addedBuTypeClass {
  width: 100%;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}
.view-btn {
  float: right;
  cursor: pointer;
  margin-right: 30px;
  margin-top: 70px;
}
.view-btn-bu {
  float: right;
  cursor: pointer;
  margin-right: 20px;
}
.view-btn-bu-2 {
  float: right;
  cursor: pointer;
  margin-right: 30px;
  margin-bottom: 30px;
}
.view-all-btn {
  height: 35px;
  border-radius: 4px;
  cursor: pointer;
}
.addbtn {
  float: right;
  button {
    display: flex;
  }
  margin-top: -45px;
  margin-left: auto;
  span {
    color: #34c0be;
    margin-left: 5px;
    margin-top: 5px;
  }
}
.position-fixed {
  width: calc(100% - 200px);
  margin-top: 105px;
}
.addbtnbu {
  float: right;
  button {
    display: flex;
  }
  margin-top: -14px;
  span {
    color: #34c0be;
    margin-left: 5px;
    margin-top: 5px;
  }
}
.custom-grid {
  display: grid;
  grid-template-columns: 15% 68% 15%;
  grid-gap: 1%;
  margin: 20px 15px;
  .action-menu {
    text-align: right;
    .favourite {
      margin-right: 15px;
    }
  }
}
.container-le-list {
  margin-bottom: 50px;
}
.showLeDetails {
  max-height: 450px;
  overflow-y: scroll;
}
.le-name {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
